import { render } from "./CustomerBlock.vue?vue&type=template&id=7342c1e2&scoped=true"
import script from "./CustomerBlock.vue?vue&type=script&lang=js"
export * from "./CustomerBlock.vue?vue&type=script&lang=js"

import "./CustomerBlock.vue?vue&type=style&index=0&id=7342c1e2&lang=scss&scoped=true"

import exportComponent from "/home/vsts/work/1/s/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-7342c1e2"]])

export default __exports__